import React from 'react';
import EcoClub3Class2025 from '../views/EcoClub3Class2025/EcoClub3Class2025';

const DesktopAppPage = () => {
  return <EcoClub3Class2025 />;
};

export default DesktopAppPage;
